import { Translate } from '@change-corgi/core-react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { ProgressIndicator } from '@change-corgi/design-system-legacy/components/navigation';
import { iconFlag } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { useIsSunriseEnabled } from '../../../hooks/isSunriseEnabled';

type Props = {
	signatureCount: number;
	nextMilestone: number;
};

export const SignatureThermometer = ({ signatureCount, nextMilestone }: Props): JSX.Element | null => {
	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();

	if (!nextMilestone) return null;

	return (
		<Flex
			data-testid="signature-thermometer-container"
			sx={{
				backgroundColor: isSunriseEnabled ? '' : 'rgba(21, 125, 185, 0.05)',
				borderRadius: 8,
				flexDirection: 'column',
				gap: 8,
				padding: isSunriseEnabled ? '' : '14px 12px',
			}}
		>
			<Flex sx={{ gap: 8 }}>
				<Flex sx={{ backgroundColor: 'rgba(0, 107, 169, 0.1)', borderRadius: 12, padding: 5, width: 24, height: 24 }}>
					<Icon
						size="s"
						icon={iconFlag}
						data-testid="signatures-milestone-flag-icon"
						sx={{
							color: 'secondary-blue',
						}}
					/>
				</Flex>
				<Text size="small" fontWeight="bold">
					<Translate
						value="corgi.petition_gamma.details.signature_thermometer.title"
						replacements={{ nextMilestone }}
					/>
				</Text>
			</Flex>

			<ProgressIndicator
				variant="blue"
				completionPercentage={Math.floor((signatureCount / nextMilestone) * 100)}
				sx={{
					height: 12,
					...(isSunriseEnabled && {
						height: '10px',
						'& > div:first-child': {
							backgroundColor: 'rgba(64, 58, 73, 0.05)',
						},
						'& > div:last-child': {
							borderColor: 'transparent',
						},

						'& > div > div': {
							background: 'sunrise.gradient.fill.progress',
							borderRadius: 'standard',
						},
					}),
				}}
			/>
			<Text size="small">
				<Translate value="corgi.petition_gamma.details.signature_thermometer.body" />
			</Text>
		</Flex>
	);
};
